import { unauthorizedRoutesParam } from '../../constants/routes';
export const defaultAccountsProps = {
  usageTracker: {
    trackInteraction: () => undefined,
    trackPageView: () => undefined,
    trackUsage: () => undefined
  },
  canViewParticipants: true,
  screenName: '',
  routes: {
    contacts: '/contacts',
    associations: '/associations',
    base: '/in-meeting-experience-ui-components-kitchen-sink',
    accounts: '/accounts',
    reconnect: '/reconnect'
  },
  unauthorizedRoutesParam,
  apiWrapper: {
    fetchAccounts: () => Promise.resolve([]),
    fetchUserInfo: () => Promise.resolve({
      userId: 0,
      email: '',
      firstName: '',
      lastName: '',
      enabledGates: [],
      locale: {
        locale: 'en',
        langEnabled: false
      }
    })
  },
  openUrl: url => {
    window.open(url, '_blank');
  },
  connectNewAccountUrl: ''
};